const getAfterProfilePanelUrl = (state: WebOrder.State): string =>
  state.general.afterProfilePanelUrl;

export const generalSelectors = {
  getAfterProfilePanelUrl,
};
